module.exports = __webpack_public_path__ + "static/media/test2.0cd22bed.jpg";